<template>
	<label :class="['label', options.className]" v-if="isVisible">
		<span
			v-html="computedLabel"
			:class="[options.innerClass, { [options.ifNullClass]: computedLabel === options.ifNull }]"
		></span>
		<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
	</label>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';
import { formatter } from '@/modules/currency';

export default {
	mixins: [shared],
	computed: {
		computedLabel() {
			let data = this.options.label;

			if (_.has(this.options, 'fromData')) {
				data = this.getDataByGroup(this.options.inputGroup, this.index)[this.options.fromData];
			}

			if (_.has(this.options, 'getter')) {
				data = this.$store.getters[this.options.getter];
			}

			if (_.has(this.options, 'sumBy')) {
				data = _.sumBy(data, this.options.sumBy);
			}

			if (data === null || data === undefined || data === 0) {
				if (_.has(this.options, 'ifNull')) {
					return this.options.ifNull;
				}
			}

			if (_.has(this.options, 'currency')) {
				data = formatter(this.options.currency).format(data);
			}

			return data;
		},
	},
};
</script>
